import React from 'react';
import {
    Typography,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    IconButton,
} from '@mui/material';
import { Edit as EditIcon, Delete } from '@mui/icons-material';

const secondsToTime = (seconds) => {
    if (seconds === null || seconds === undefined) return '-';
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    return `${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
};

function SummaryTable({ entries, carTypes, allDriverPayouts, editingIndex, onEdit, onRemove, showPartnerColumn, mappingType }) {
    const getCarTypeLabel = (id) => carTypes.find((ct) => ct.value === id)?.label || '-';
    const getPayoutLabel = (id) => allDriverPayouts.find((p) => p.id === id)?.name || '-';
    const getPayoutField = (id, field) => {
        const p = allDriverPayouts.find((p) => p.id === id);
        return p?.[field] !== null && p?.[field] !== undefined ? p[field] : null;
    };

    if (entries.length === 0) {
        return (
            <Typography variant="body2" color="textSecondary" sx={{ textAlign: 'center', py: 3 }}>
                No driver payouts added yet. Use the form above to add one.
            </Typography>
        );
    }

    return (
        <Table sx={{ border: '1px solid rgba(217, 217, 217, 1)', borderRadius: '8px' }}>
            <TableHead>
                <TableRow sx={{ bgcolor: 'rgba(225, 244, 228, 1)' }}>
                    {showPartnerColumn && <TableCell sx={{ fontWeight: 'bold' }}>Corporate Client</TableCell>}
                    {showPartnerColumn && <TableCell sx={{ fontWeight: 'bold' }}>Ride Type</TableCell>}
                    {showPartnerColumn && <TableCell sx={{ fontWeight: 'bold' }}>Package</TableCell>}
                    <TableCell sx={{ fontWeight: 'bold' }}>Car Type</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Driver Payout</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Time From</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Time To</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Initial Distance</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Initial Dist. Charge</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Per Km Charge</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Deduction %</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', width: '100px' }}>Actions</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {entries.map((entry, index) => (
                    <TableRow
                        key={index}
                        sx={{
                            '&:hover': { bgcolor: '#f9f9f9' },
                            bgcolor: editingIndex === index ? 'rgba(225, 244, 228, 0.3)' : 'inherit',
                        }}
                    >
                        {showPartnerColumn && <TableCell>{entry.corporateClientLabel || '-'}</TableCell>}
                        {showPartnerColumn && <TableCell>{entry.rideTypeLabel || '-'}</TableCell>}
                        {showPartnerColumn && <TableCell>{entry.packagesLabel || '-'}</TableCell>}
                        <TableCell>{getCarTypeLabel(entry.carTypeId)}</TableCell>
                        <TableCell>{getPayoutLabel(entry.driverPayoutId)}</TableCell>
                        <TableCell>{secondsToTime(getPayoutField(entry.driverPayoutId, 'timeFrom'))}</TableCell>
                        <TableCell>{secondsToTime(getPayoutField(entry.driverPayoutId, 'timeTo'))}</TableCell>
                        <TableCell>{getPayoutField(entry.driverPayoutId, 'initialDistance') ?? '-'}</TableCell>
                        <TableCell>{getPayoutField(entry.driverPayoutId, 'initialDistanceCharge') ?? '-'}</TableCell>
                        <TableCell>{getPayoutField(entry.driverPayoutId, 'perKmCharge') ?? '-'}</TableCell>
                        <TableCell>{entry.percentage ? `${entry.percentage}%` : '-'}</TableCell>
                        <TableCell>
                            <IconButton
                                size="small"
                                onClick={() => onEdit(index)}
                                disabled={editingIndex !== null && editingIndex !== index}
                                sx={{ color: '#39B54A', mr: 0.5 }}
                            >
                                <EditIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                                size="small"
                                onClick={() => onRemove(index)}
                                sx={{ color: 'red' }}
                            >
                                <Delete fontSize="small" />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}

export default SummaryTable;
